/**
 * Truncates a string to a specified length.
 * @param str - The string to truncate.
 * @param maxLength - The maximum allowed length (including the suffix).
 * @param suffix - Optional suffix to append (default: "...").
 * @returns The truncated string.
 */
export const truncate = (
  str: string,
  maxLength: number,
  suffix: string = "..."
): string => {
  if (!str) return "";

  // If the string is already short enough, return it as is
  if (str.length <= maxLength) return str;

  // Calculate where to cut so that (cut string + suffix) <= maxLength
  // We ensure we don't cut into negative indices if maxLength is very small
  const charsToShow = Math.max(0, maxLength - suffix.length);

  return str.slice(0, charsToShow) + suffix;
};
